import { Userpilot } from "userpilot";
import { callMvcApi } from "../../call-web-api";

export const initUserpilot = async (currentUser) => {
    if (!currentUser?.userId) return;

    try {
        const response = await callMvcApi({
            url: "/api/userpolicysettings/settings",
            method: "GET",
        });

        const token = response?.token;
        if (!token) return;

        Userpilot.initialize(token);

        Userpilot.identify(currentUser.userId, {
            name: currentUser.loggedInUserDisaplyName,
            company: {
                id: currentUser.clientId,
                name: currentUser.clientName,
            },
        });
    } catch (error) {
        console.error("Userpilot initialization failed", error);
    }
};

export const trackUserpilotPage = () => {
    Userpilot.reload();
};